import type { BuyerFundingFlowPaymentRequest } from "../flows/buyerFunding/types";

type BuyerInviteStepProps = {
  officeName: string;
  fileCode: string;
  buyerName: string;
  buyerEmail?: string;
  amountDueLabel: string;
  paymentRequest: BuyerFundingFlowPaymentRequest;
  buyerLink: string;
  sentAt?: string;
  onGetStarted: () => void;
};

export function BuyerInviteStep({
  onGetStarted
}: BuyerInviteStepProps) {
  return (
    <section className="py-5 text-center sm:py-7" data-testid="buyer-invite-phone">
      <div className="mx-auto max-w-sm">
          <button
            className="button-primary w-full"
            data-testid="buyer-invite-start"
            type="button"
            onClick={onGetStarted}
          >
            Get started
          </button>
      </div>
    </section>
  );
}
